"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:6.5.2'] && _();
}
catch (e) { }
